export { default } from './UserBlackListService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/services/UserBlackListService/index.js